import { Link } from 'react-router-dom';
import DashboardHeader from '../../../shared/components/DashboardHeader';
import { useSecretaryStatus } from '../hooks/useSecretaryStatus';

function ClassSecretaryPage() {
  const { status, loading, error } = useSecretaryStatus();

  return (
    <div className="h-dvh w-full flex flex-col bg-appbg overflow-hidden">
      <DashboardHeader title="Class Attendance" backTo="/student-dashboard" />

      <div className="flex-1 min-h-0 overflow-y-auto">
        <main className="w-full p-4 lg:w-3/4 lg:mx-auto space-y-4">
          {loading ? (
            <p className="w-full text-center text-gray-500 py-12">Loading…</p>
          ) : error ? (
            <p className="w-full text-center text-red-600 py-12">{error}</p>
          ) : !status ? (
            <p className="w-full text-center text-gray-500 py-12">
              You aren't currently a class secretary. Ask your adviser if you should be.
            </p>
          ) : (
            <>
              <div>
                <h2 className="text-xl font-semibold text-[#0b4a71]">
                  Grade {status.student.grade_level} - {status.student.section}
                </h2>
                <p className="text-sm text-gray-500">Pick a subject to check or update attendance.</p>
              </div>

              <div className="space-y-3">
                {status.subjects.length === 0 ? (
                  <p className="text-center text-gray-500 py-8">No subjects are assigned to your section yet.</p>
                ) : (
                  status.subjects.map((subject) => (
                    <Link
                      key={subject.subjectId}
                      to={`/student-dashboard/secretary/${subject.subjectId}`}
                      className="block bg-white rounded-lg border border-gray-200 p-4 hover:border-[#4ea6d0]"
                    >
                      <p className="font-semibold text-[#0b4a71]">{subject.name}</p>
                      <p className="text-xs text-gray-500">{subject.category} - {subject.teacher}</p>
                    </Link>
                  ))
                )}
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
}

export default ClassSecretaryPage;
